import i18n from 'config/i18n';
import * as yup from 'yup';

import { PremiumPayFlagsEnum } from '../../types';

import { isSvcTypeBonus } from '../../utils/utils';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), ['common']);

const checkBoxSchema = {};

for (const key of Object.keys(PremiumPayFlagsEnum)) {
  checkBoxSchema[key] = yup.boolean().default(false);
}

export const schema = yup.object({
  claCode: yup.string().required(t('premiumPays.form.errors.claRequired')),
  bonusTypeSvc: yup
    .object()
    .shape({
      value: yup
        .string()
        .required(t('premiumPays.form.errors.typeRequired'))
        .typeError(t('premiumPays.form.errors.typeRequired'))
    })
    .default(undefined)
    .required(t('premiumPays.form.errors.typeRequired'))
    .typeError(t('premiumPays.form.errors.typeRequired')),
  bonus25Method: yup.string(),
  columnNr: yup
    .number()
    .min(0, t('validation.greaterThan', { value: 0 }))
    .required(t('premiumPays.form.errors.columnNrRequired'))
    .typeError(t('premiumPays.form.errors.columnNrRequired')),
  percentage: yup
    .number()
    .min(0, t('validation.greaterThan', { value: 0 }))
    .max(1, t('validation.lessThan', { value: 1 }))
    .required(t('premiumPays.form.errors.percentageRequired'))
    .typeError(t('premiumPays.form.errors.percentageRequired')),
  timeFrom: yup
    .date()
    .nullable()
    .default(null)
    .required(t('premiumPays.form.errors.timeFromRequired'))
    .typeError(t('validation.invalid', { name: t('timeFrom') })),
  timeTo: yup
    .date()
    .nullable()
    .default(null)
    .required(t('premiumPays.form.errors.timeToRequired'))
    .typeError(t('validation.invalid', { name: t('timeTo') })),
  timeFromThr: yup
    .date()
    .nullable()
    .default(null)
    .when('flags.TIME_FROM_THR', {
      is: true,
      then: yup
        .date()
        .required(t('premiumPays.form.errors.timeFromThrRequired'))
        .typeError(t('premiumPays.form.errors.timeFromThrRequired'))
    }),
  timeToThr: yup
    .date()
    .nullable()
    .default(null)
    .when('flags.TIME_TO_THR', {
      is: true,
      then: yup
        .date()
        .required(t('premiumPays.form.errors.timeToThrRequired'))
        .typeError(t('premiumPays.form.errors.timeToThrRequired'))
    }),
  maxHoursPerDayrange: yup
    .number()
    .nullable()
    .default(null)
    .when('bonusTypeSvc', {
      is: (bonusTypeSvc) => {
        return isSvcTypeBonus(bonusTypeSvc?.label);
      },
      then: yup.number().nullable().default(0)
    }),
  dayrange: yup.number().nullable().default(undefined),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .typeError(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .default(null),
    to: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .typeError(t('validationFieldRequired', { name: t('validTo') }))
      .nullable()
      .default(null)
      .min(yup.ref<Date>('from'), t('premiumPays.form.errors.invalidInterval'))
  }),
  flags: yup.object({ ...checkBoxSchema })
});
